class CandidateCache {
  private static cache: Record<string, string> = {};

  static get(input: string): string | undefined {
    return this.cache[input];
  }

  static set(input: string, candidates: string[]) {
    const existing = this.cache[input];
    this.cache[input] = existing ? `${existing} ${candidates.join(' ')}` : candidates.join(' ');
  }

  static setCandidates(input: Record<string, string>) {
    this.cache = { ...this.cache, ...input };
  }

  static getAll(): Record<string, string> {
    return this.cache;
  }

  static clear(input?: string) {
    if (input) {
      delete this.cache[input];
    } else {
      this.cache = {};
    }
  }
}

export default CandidateCache;